export default {
  SET_COMPETITIONS_FULL(state, competitions) {
    state.competitions_full = competitions;
  },
  SET_COMPETITIONS_PARTIAL(state, competitions) {
    state.competitions_partial = competitions;
  },
  SET_COMPETITION_CURRENT(state, competition) {
    state.competition = competition;
  },
}
